// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---node-modules-gatsby-plugin-offline-app-shell-js": () => import("/Users/danieldavidson/Desktop/new_wedding/node_modules/gatsby-plugin-offline/app-shell.js" /* webpackChunkName: "component---node-modules-gatsby-plugin-offline-app-shell-js" */),
  "component---src-pages-404-js": () => import("/Users/danieldavidson/Desktop/new_wedding/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-generic-js": () => import("/Users/danieldavidson/Desktop/new_wedding/src/pages/generic.js" /* webpackChunkName: "component---src-pages-generic-js" */),
  "component---src-pages-index-js": () => import("/Users/danieldavidson/Desktop/new_wedding/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

exports.data = () => import(/* webpackChunkName: "pages-manifest" */ "/Users/danieldavidson/Desktop/new_wedding/.cache/data.json")

